export default {
    loaded: true,
    data: {
        dueDate: null,
        routes: [],
    },
}
